import { useCallback } from 'react';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import { PostPolicyAction, usePostPolicyCheck } from '../post/postPolicyCheck';
import type { UserRole } from '../topic/topicPolicyCheck';

export enum SeriesPolicyAction {
  EditSeries,
}

const USE_SERIES_POLICY_CHECK_SERIES_FRAGMENT = gql(`
  # eslint-disable-next-line @graphql-eslint/require-selections
  fragment useSeriesPolicyCheck_series on SeriesFields {
    ... on Series {
      posts {
        id
        ...usePostPolicyCheck_post
      }
    }
  }
`);

const useSeriesPolicyCheck = () => {
  const postPolicyCheck = usePostPolicyCheck();
  return useCallback(
    (
      action: SeriesPolicyAction,
      series: DocumentType<typeof USE_SERIES_POLICY_CHECK_SERIES_FRAGMENT>,
      user: UserRole | { id: string },
    ) => {
      switch (action) {
        case SeriesPolicyAction.EditSeries:
          return (
            'posts' in series &&
            (series.posts.length === 0 ||
              series.posts.some((post) =>
                postPolicyCheck(PostPolicyAction.EditPost, post, user),
              ))
          );
        default:
          return false;
      }
    },
    [postPolicyCheck],
  );
};

export default useSeriesPolicyCheck;
